export default "/images/vendor/@coreui/icons/svg/flag/cif-vn.svg?5802e2ca09fe2dc70e95ccdb96042f5d";